import { configureStore } from '@reduxjs/toolkit';
import projectReducer from "./projectSlice";
import savesReducer from "./savesSlice";
import systemReducer from "./systemSlice";

import { saveState, loadState } from "./localStorage";
import settings from "../Story/settings";
import variables from "../Story/variables";

export const getPreloadedState = () => {
  let state = loadState();
  console.warn('getPreloadedState:', state);
  if (state === undefined) {
    state = {
      project: {
        passages: {
          current: settings.passages.start,
          start: settings.passages.start,
          background: "default"
        },
        variables: variables.getInit(),
        dialog: {
          content: null
        }
      }
    };
  } else {
    variables.update(state.project.variables);
    if (settings.project.debug) {
      state.project.variables = variables.getJSON();
      state.project.passages.current = settings.passages.start;
    }
  }

  return state;
};

export const store = configureStore({
  reducer: {
    project: projectReducer,
    saves: savesReducer,
    system: systemReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  }),
  preloadedState: getPreloadedState()
});

// We'll subscribe to state changes, saving the store's state to the browser's
// local storage. We'll throttle this to prevent excessive work.
store.subscribe(
    () => {
      if (!settings.project.debug) {
        saveState(store.getState())
      }
    }
);
